<template>
	<AmeliproDialog
		v-model="opened"
		:labelledby="`${uniqueId}-title`"
		no-click-animation
		:persistent="persistent"
		:unique-id="uniqueId"
	>
		<template #header>
			<h2
				:id="`${uniqueId}-title`"
				class="ma-0 text-h4"
			>
				{{ title }}
			</h2>
		</template>

		<template #default>
			<div class="d-flex amelipro-ondoarding__content">
				<div
					v-if="breakpointHelper.isDesktop()"
					class="py-0 pr-4 amelipro-ondoarding__content--left"
					:style="imgWrapperStyle"
				>
					<img
						alt=""
						class="mx-auto  d-bock"
						height="335px"
						:src="currentStep.img"
					>
				</div>

				<div
					class="py-0 amelipro-onboarding__content--right"
					:style="textWrapperStyle"
				>
					<div class="d-flex flex-column amelipro-onboarding__content--right__wrapper">
						<div class="mt-2 d-flex align-center amelipro-onboarding__dots">
							<span
								v-for="(item, index) in steps"
								:key="index"
								:aria-hidden="true"
								class="mx-1 amelipro-onboarding__step-dot"
								:class="{ 'amelipro-onboarding__active-dot': currentStepIndex === index }"
							/>
							<p class="ml-2 mb-0">
								{{ currentStepIndex + 1 }}/{{ steps.length }}
							</p>
						</div>

						<h3 class="font-weight-bold mt-4 mb-6 amelipro-onboarding__content__title">
							{{ currentStep.title }}
						</h3>

						<p
							v-for="(content, index) in currentStep.content"
							:key="index"
							class="amelipro-onboarding__content__text"
						>
							{{ content }}
						</p>

						<div class="d-flex justify-space-between align-center amelipro-onboarding__content__btn-wrapper">
							<AmeliproBtn
								v-if="currentStepIndex < steps.length - 1"
								class="mt-6 mb-2  amelipro-onboarding__content__btn--next"
								@click="nextStep"
							>
								Suivant
							</AmeliproBtn>

							<AmeliproBtn
								v-else
								class="mt-6 mb-2  amelipro-onboarding__content__btn--final"
								@click="opened = false"
							>
								{{ finalBtnLabel }}
							</AmeliproBtn>

							<AmeliproBtn
								v-if="!persistent"
								class="mt-6 mb-2  amelipro-onboarding__content__btn--skip"
								text
								@click="opened = false"
							>
								{{ skipBtnLabel }}
							</AmeliproBtn>
						</div>
					</div>
				</div>
			</div>
		</template>
	</AmeliproDialog>
</template>

<script setup lang="ts">
	import { PropType, computed, ref } from 'vue';
	import BreakpointHelper from '../../helpers/BreakpointHelper';
	import { IOnboarding } from './types';

	const props = defineProps({
		finalBtnLabel: {
			type: String,
			default: 'Commencer',
		},
		imgWidth: {
			type: String,
			default: '35%',
		},
		persistent: {
			type: Boolean,
			default: false,
		},
		skipBtnLabel: {
			type: String,
			default: 'Passer',
		},
		steps: {
			type: Array as PropType<IOnboarding[]>,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
		uniqueId: {
			type: String,
			required: true,
		},
		value: {
			type: Boolean,
			default: false,
		},
		width: {
			type: String,
			default: '800px',
		},
	});

	const emit = defineEmits(['input']);

	const opened = computed({
		get: (): boolean => props.value,
		set: (newValue: boolean): void => {
			emit('input', newValue);
		},
	});
	const currentStepIndex = ref(0);
	const nextStep = () => {
		currentStepIndex.value += 1;
	};
	const breakpointHelper = new BreakpointHelper();

	const currentStep = computed<IOnboarding>(() => props.steps[currentStepIndex.value]);

	const imgWrapperStyle = computed<string>(() => `width: ${props.imgWidth};`);
	const textWrapperStyle = computed<string>(() => (breakpointHelper.isDesktop() ? `width: calc(100% - ${props.imgWidth});` : 'width: 100%;'));
</script>

<style lang="scss" scoped>
	.amelipro-ondoarding-content {
		min-height: 350px;
	}

	.amelipro-onboarding__content--right__wrapper {
		min-height: 100%;
	}
	.amelipro-onboarding__step-dot {
		width: 14px;
		height: 14px;
		border-radius: 50%;
		border: 2px solid $ap-blue-darken1;
		background-color: $ap-white;

		&.amelipro-onboarding__active-dot {
			background-color: $ap-blue-darken1;
		}
	}

	.amelipro-onboarding__content__btn-wrapper {
		margin-top: auto;
	}
</style>
